module.exports = __webpack_public_path__ + "h5/img/huodongbanne.69a1901f.jpg";